'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthHookTranslations = require('@narvar/nth-hook-translations');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const TrackingStatusText = () => {
  const {
    trackingStatus
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, trackingStatus);
};
var TrackingStatusText$1 = nthHookTranslations.withTranslationsProvider(TrackingStatusText, {
  translationKeys: ['trackingStatus']
});

exports["default"] = TrackingStatusText$1;
